module.exports = __webpack_public_path__ + "img/editarTrt.e15bc473.svg";